import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select, Pagination } from 'components';
import { ComboService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { ArrowLeftWhite, CleanIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	title?: string;
	products?: any;
}

const INITIAL_STATE = {
	search: ''
}

class ModalSelectProducts extends React.Component<Props> {

	timer: any = undefined;

	state = {
		page: 1,
		last_page: 1,
		data: [],
		form: INITIAL_STATE,
		products: this.props.products || []
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ComboService.admin.getProducts({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.products.rows,
			last_page: res.products.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}
	
	render() {
		const { data } = this.state;

		return (
			<div id="modal-select-products">
				<div className="row row-title-blue">
					<div className="col-2">
						<button className="btn-close" onClick={ () => this.props.onClose() }>
							<img src={ ArrowLeftWhite } />
						</button>
					</div>
					<div className="col-8">
						<h4>{ this.props.title }</h4>
					</div>
				</div>
				<div className="container-padding container-input-products">
					<Input
						searchLeft
						value={ this.state.form.search }
						name="search"
						placeholder="Nombre del producto"
						className="input-table"
						onSubmit={ () => this.load() }
						onChange={ (e: any) => {
							clearTimeout(this.timer);
							this.timer = setTimeout(() => {
								this.load(true);
							},1000);
							this.change(e); 
						} } />
					{
						this.state.form != INITIAL_STATE && (
							<button className="btn btn-clean" onClick={ () => this.reset() }>
								<img src={ CleanIcon } />
							</button>
						)
					}
				</div>

				<table className="table">
					<tr className="tr-header">
						<th style={{ width: '70%' }}>Producto</th>
						<th style={{ width: '30%' }} className="text-right">Presentación</th>
					</tr>
					{
						data.map((item: any, index: number) => {
							return (
								<tr>
									<td>
										<div className="item-circle" onClick={ () => {
											let products: any = [...this.state.products];
											const _index = products.map((i: any) => i.id).indexOf(item.id);
											if (_index != -1) {
												products.splice(_index,1);
											}
											else {
												products.push(item);
											}
											this.setState({
												products
											});
										} }>
											<div className={ `circle ${ this.state.products.map((i: any) => i.id).indexOf(item.id) != -1 ? 'active' : '' }` }></div>
											{ item?.name }
										</div>
									</td>
									<td className="text-right">
										{ item?.presentation?.name }
									</td>
								</tr>
							)
						})
					}
				</table>

				<div className="container-padding">
					<Pagination 
						pages={ this.state.last_page } 
						active={ this.state.page }
						onChange={ async (page: number) => {
							await this.setState({
								page: page
							});
							this.load();
						} } />

					<div className="text-center">
						<Button type="submit" onClick={ () => this.props.onClose(this.state.products) }>
							Guardar
						</Button>
					</div>
					{
						this.state.products.length > 0 && (
							<div className="row row-selected">
								<div className="col-md-6">
									<h5>Productos seleccionados:</h5>
								</div>
								<div className="col-md-6">
									<ul>
										{
											this.state.products.map((item: any, index: number) => {
												return (
													<li>{ item?.name }</li>
												)
											})
										}
									</ul>
								</div>
							</div>
						)
					}
				</div>
			</div>
		)
	}
}

export default ModalSelectProducts;